import Repo from '../repos/Repo';

//public sector
export default class UserRepo extends Repo{

    constructor($auth){
        super($auth, 'users');
        this.mePath = '/me';
        this.category = '/categories';
        this.newsPath = '/news';
    }


    update(data, include =''){
        return this.http.post(this.resource + "?include=" + include, data).then((response) => {
            return Promise.resolve(response);
        }).catch((response) =>{
            return Promise.reject(response);
        });
    }

    news(paginate = false){
        var path = this.newsPath;
        if(paginate){
            path += "/paginate";
        }

        return this.http.get(this.resource + path + "?include=&orderBy=created_at,desc").then((response) => {
            return Promise.resolve(response);
        }).catch((response) =>{
            return Promise.reject(response);
        });
    }
    sentences(){            
        return this.http.get(this.resource + this.mePath + "?include=sentences.categories").then((response) => {
            return Promise.resolve(response);
        }).catch((response) =>{            
            return Promise.reject(response);
        });
    } 
    
    commentsHistory(page = 1, pagination = 6){
        return this.http.get(this.resource + this.mePath + "/comments/history?include=sentences.categories&orderBy=updated_at,desc&page=" + page + "&pagination=" + pagination).then((response) => {
            return Promise.resolve(response);
        }).catch((response) =>{            
            return Promise.reject(response);
        });
    }

    favComments(data, page = 1, pagination = 6){
        return this.http.post(this.resource + this.mePath + "/comments/favorite?include=sentences.categories&page=" + page + "&pagination=" + pagination, data).then((response) => {
            return Promise.resolve(response);
        }).catch((response) =>{
            return Promise.reject(response);
        });
    }

    studentComments(student_id, page = 1, pagination = 6){
        return this.http.get(this.resource + this.mePath + "/student/" + student_id + "/comments?include=sentences.categories&orderBy=updated_at,desc&page=" + page + "&pagination=" + pagination).then((response) => {
            return Promise.resolve(response);
        }).catch((response) =>{
            return Promise.reject(response);
        });
    }

    attachCategory(id, data){
        return this.http.post(this.resource + this.category + "/" + id + '?include=categories&orderBy=order,asc', data).then((response) => {
            return Promise.resolve(response);
        }).catch((response) =>{
            return Promise.reject(response);
        });
    }

    syncCategory(id, data){
        return this.http.put(this.resource + this.category + "/" + id + '?include=categories&orderBy=order,asc', data).then((response) => {
            return Promise.resolve(response);
        }).catch((response) =>{
            return Promise.reject(response);
        });
    }

    reorderCategory(data){
        return this.http.post(this.resource  + "/reorder"  + this.category+ '?include=categories&orderBy=order,asc', data).then((response) => {
            return Promise.resolve(response);
        }).catch((response) =>{
            return Promise.reject(response);
        });
    }

    detachCategory(id){
        return this.http.delete(this.resource + this.category + "/" + id ).then((response) => {
            return Promise.resolve(response);
        }).catch((response) =>{
            return Promise.reject(response);
        });
    }

    me(){
        return this.http.get(this.resource + this.mePath + "?include=news").then((response) => {
            return Promise.resolve(response);
        }).catch((response) =>{
            return Promise.reject(response);
        });
    }

    stats(){
        return this.http.get(this.resource + this.mePath + "/stats").then((response) => {
            return Promise.resolve(response);
        }).catch((response) =>{
            return Promise.reject(response);
        });
    }
   
}


// WEBPACK FOOTER //
// ./src/repos/UserRepo.js